import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { clientStatusLabel } from '@/utils/deliveryHelpers';
import { Download, Check, RotateCcw } from 'lucide-react';

const DeliveryFileCard = ({
  file,
  mode = 'client',
  onApproveFile,
  onRequestRevision,
  onDownload,
  loadingAction,
}) => {
  const isVideo = (file.content_type || '').startsWith('video/');
  const preview = file.preview_url;
  const status = file.client_status || 'pending';

  return (
    <div className="rounded-xl border border-white/10 bg-white/5 overflow-hidden">
      <div className="aspect-video bg-black/40 flex items-center justify-center">
        {preview ? (
          isVideo ? (
            <video src={preview} controls className="max-h-full max-w-full" playsInline />
          ) : (
            <img src={preview} alt={file.filename} className="max-h-full max-w-full object-contain" />
          )
        ) : (
          <p className="text-sm text-white/50 px-4 text-center">
            {file.processing_status === 'processing'
              ? 'Processando preview…'
              : 'Preview indisponível'}
          </p>
        )}
      </div>
      <div className="p-4 space-y-3">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="font-medium text-sm truncate">{file.filename}</p>
            <p className="text-xs text-white/50">
              {file.file_size
                ? `${(file.file_size / (1024 * 1024)).toFixed(1)} MB`
                : ''}
            </p>
          </div>
          <Badge variant="outline" className="shrink-0 border-white/20 text-white/80">
            {clientStatusLabel(status)}
          </Badge>
        </div>
        {mode === 'client' && status === 'pending' && (
          <div className="flex flex-wrap gap-2">
            <Button
              size="sm"
              disabled={loadingAction}
              onClick={() => onApproveFile?.(file)}
              className="bg-[#0E76FF] hover:bg-[#2563EB]"
            >
              <Check className="h-3 w-3 mr-1" />
              Aprovar
            </Button>
            <Button
              size="sm"
              variant="outline"
              disabled={loadingAction}
              onClick={() => onRequestRevision?.(file)}
              className="border-white/20"
            >
              <RotateCcw className="h-3 w-3 mr-1" />
              Pedir revisão
            </Button>
          </div>
        )}
        {mode === 'client' && onDownload && (
          <Button
            size="sm"
            variant="secondary"
            className="w-full"
            onClick={() => onDownload(file)}
          >
            <Download className="h-3 w-3 mr-1" />
            Baixar original
          </Button>
        )}
        {file.revision_message && (
          <p className="text-xs text-amber-200/90 bg-amber-500/10 rounded p-2">
            {file.revision_message}
          </p>
        )}
      </div>
    </div>
  );
};

export default DeliveryFileCard;
